import axios from 'axios';
import { CaseDto } from '../contexts/useCases';
import { Case } from '../models/common-types';
import { PENDO_EVENTS, pendoTrack } from '../utils/pendo';

const prefix = '/api/osint';

export class CasesAPI implements CasesApi {
    async deleteCase(wsId: number, caseId: string): Promise<object> {
        return await axios.delete<Case>(`${prefix}/workspaces/${wsId}/cases/${caseId}`);
    }

    async updateCase(wsId: number, caseId: string, caseData: CaseDto): Promise<object> {
        return await axios.put<Case>(`${prefix}/workspaces/${wsId}/cases/${caseId}`, caseData);
    }

    async createCase(wsId: number, caseData: CaseDto): Promise<object> {
        pendoTrack(PENDO_EVENTS.CREATE_CASE, { name: caseData.name, description: caseData.description });
        return await axios.post<Case>(`${prefix}/workspaces/${wsId}/cases`, caseData);
    }

    async fetchCases(wsId: number): Promise<Case[]> {
        try {
            const { data } = await axios.get<Case[]>(`${prefix}/workspaces/${wsId}/cases`);

            if (data.length > 0) {
                return data;
            } else {
                await axios.post<Case>(`${prefix}/workspaces/${wsId}/cases`, {
                    name: 'New Case',
                    description: 'Default case',
                    parentId: null,
                });

                const cases = await axios.get<Case[]>(`${prefix}/workspaces/${wsId}/cases`);
                return cases.data;
            }
        } catch (error) {
            return null;
        }
    }
}

export interface CasesApi {
    createCase(wsId: number, caseData: CaseDto): Promise<object>;
    fetchCases(wsId: number): Promise<Case[]>;
    updateCase(wsId: number, caseId: string, caseData: CaseDto): Promise<object>;
    deleteCase(wsId: number, caseId: string): Promise<object>;
}
